

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar';
import Footer from './components/footer';
import Home from './pages/Home';
import Corporate from './pages/corporate';
import Cities from './pages/Cities';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import DataDeletion from './pages/DataDeletion';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/corporate" element={<Corporate />} />
          <Route path="/cities" element={<Cities />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
